module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = ../../../../readable-stream/lib/internal/streams/stream-browser.js
// module chunks = vendor